var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.twilioMessagesCounter > 0)?[_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v(_vm._s(_vm.twilioMessagesCounter))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }